import request from '@/utils/request';

/**
 * 支付商户列表
 * @param params
 */
export function previewProductListApi(params) {
  return request({
    url: 'admin/platform/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增支付商户
 * @param data
 */
export function previewProductCreateApi(data) {
  return request({
    url: 'admin/platform/product/create',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑支付商户
 * @param data
 */
export function previewProductUpdateApi(data) {
  return request({
    url: 'admin/platform/product/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除支付商户
 */
export function previewProductDeleteApi(id) {
  return request({
    url: "admin/platform/product/delete",
    method: 'POST'
  });
}

/**
 * 支付商户详情
 * @param id
 */
export function previewProductDetailApi(id) {
  return request({
    url: "admin/platform/product/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 启用支付商户
 * @param data
 */
export function previewProductEnableApi(data) {
  return request({
    url: "admin/platform/product/shelf/on",
    method: 'POST',
    data: data
  });
}

/**
 * 禁用支付商户
 * @param data
 */
export function previewProductDisableApi(data) {
  return request({
    url: "admin/platform/product/shelf/off",
    method: 'POST',
    data: data
  });
}